interface IsNumberInRangeParams {
  number: number
  startRange: number
  endRange: number
}

export const isNumberInRange = ({ number, startRange, endRange }: IsNumberInRangeParams): boolean => (
  number >= startRange && number <= endRange
);
